<section class="about-walk-section" *ngIf="section">
  <div class="about-walk-inner">
    <div class="about-walk-head">
      <p class="about-walk-eyebrow">{{ section.sectionEyebrow }}</p>
      <h2>
        <span>{{ section.headingLineOne }}</span>
        <span class="about-walk-accent">{{ section.headingLineTwo }}</span>
      </h2>
      <p class="about-walk-subtitle">{{ section.subtitle }}</p>
    </div>
    <div class="about-walk-cards">
      <app-about-walk-card
        *ngFor="let card of section.cards"
        [card]="card"
      ></app-about-walk-card>
    </div>
  </div>
</section>
